export default {
  HTTP_ERRORS: {
    401: 'You are unauthorized to access this resource.',
    403: 'You do not have sufficient privileges. Please check with your Administrator.',
    unauthorized_client: 'You are unauthorized to access this application.',
    access_denied:
      'You do not have sufficient privileges. Please check with your Administrator.',
    temporarily_unavailable:
      'Authorization server is temporarily unavailable, please check back later.',
    login_required: 'Please try to login again.'
  }
}

export const ERROR_SCREEN_MESSAGE = {
  UNAUTHORIZED: {
    heading: 'Unauthorized',
    message: "You don't have sufficient privileges to access this resource."
  },
  PAGE_NOT_FOUND: {
    heading: '404',
    message: 'Oops, the page you are looking for is not found.'
  }
}

export const FETCH_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  ERROR: 'error',
  COMPLETE: 'complete'
}

export const STATUS_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info'
}

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export const DIMENSIONS = {
  MOBILE_WIDTH: 767,
  IPAD_WIDTH: 768,
  HYBRID_WIDTH: 991
}
